import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  MenuItem,
  Snackbar,
  Alert,
  CircularProgress,
} from '@mui/material';

import { useNavigate } from 'react-router-dom';

import { ArticleType } from '../types';
import { api } from '../api';

const AddArticle: React.FC = () => {
  const [description, setDescription] = useState('');
  const [type, setType] = useState<ArticleType>(ArticleType.URL);
  const [link, setLink] = useState('');
   const [tag, setTag] = useState('');
  const [image, setImage] = useState<File | null>(null);
  const [imageError, setImageError] = useState(false);
  const [requestError, setRequestError] = useState<string | null>(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setRequestError(null);
    if (!image) {
      setImageError(true);
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append('description', description);
    formData.append('type', type);
    formData.append('link', link);
    formData.append('tag', tag);
    formData.append('image', image);

    try {
      await api.post(`/articles/add-article`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      setOpenSnackbar(true);
      setTimeout(() => navigate('/articles'), 1500);
    } catch (error: any) {
      console.log(error)
      const message =
        error.response?.data?.error ||
        error.message ||
        'Erreur lors de l’ajout de l’article.';
      setRequestError(message);
      setTimeout(() => setRequestError(null), 5000);
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setImage(file);
    setImageError(false);
  };

  return (
    <Box maxWidth="600px" mx="auto" mt={4}>
      <Typography variant="h5" gutterBottom>
        Add article
      </Typography>

      {requestError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {requestError}
        </Alert>
      )}

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <TextField
          label="Description"
          fullWidth
          margin="normal"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
          disabled={loading}
        />

        <TextField
          label="Type"
          select
          fullWidth
          margin="normal"
          value={type}
          onChange={(e) => setType(e.target.value as ArticleType)}
          required
          disabled={loading}
          
        >
          <MenuItem value={ArticleType.URL}>URL</MenuItem>
          <MenuItem value={ArticleType.AUDIO}>AUDIO</MenuItem>
          <MenuItem value={ArticleType.VIDEO}>VIDEO</MenuItem>
        </TextField>

        <TextField
          label="Link"
          type="url"
          fullWidth
          margin="normal"
          value={link}
          onChange={(e) => setLink(e.target.value)}
          disabled={loading}
          required
        />

        <TextField
          label="Tag"
          type="text"
          fullWidth
          margin="normal"
          value={tag}
          onChange={(e) => setTag(e.target.value)}
          disabled={loading}
       
        />

        {image ? (
          <Box display="flex" flexDirection="column" alignItems="center" my={2}>
            <img
              src={URL.createObjectURL(image)}
              alt="Preview"
              style={{ width: 200, height: 150, objectFit: 'cover', marginBottom: 8 }}
            />
            <Button
              variant="outlined"
              color="error"
              onClick={() => setImage(null)}
              disabled={loading}
            >
              Remove image
            </Button>
          </Box>
        ) : (
          <Box my={2}>
            <Button
              variant="outlined"
              component="label"
              fullWidth
              disabled={loading}
            >
              Choose image
              <input type="file" hidden accept="image/*" onChange={handleImageChange} />
            </Button>
            {imageError && (
              <Typography variant="body2" color="error" mt={1}>
               Image is required
              </Typography>
            )}
          </Box>
        )}

        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? 'Enregistrement...' : 'Enregistrer'}
        </Button>
      </form>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={1500}
        message="Article ajouté avec succès"
        onClose={() => setOpenSnackbar(false)}
      />
    </Box>
  );
};

export default AddArticle;
